export const getDisks = (state) => state.disks
export const getDiskDrivers = (state) => state.diskDrivers
